// @ts-nocheck

import styled from 'styled-components';

import { Section } from '../../../components/layout';
import Grid from '../../../components/layout/Grid';
import { InputNumber } from '../../../components/inputs';

export const Content = styled.div`
  padding: 16px 0;
`;
export const Footer = styled(Section)`
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const FooterSpoiler = styled.div`
  & > * {
    &:not(:last-child) {
      margin-right: 16px;
    }
  }
`;
export const StyledInputNumber = styled(InputNumber)`
  width: 100%;
`;

export const StyledGrid = styled(Grid)`
  padding: 0 16px;
`;

export const Operations = styled.div`
  display: flex;
  height: 35px;
  align-items: center;
`;
